(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4wcHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34a400a481207c26$export$2e2bcd8739ae039; });

var $1MMdM = parcelRequire("1MMdM");
var $34a400a481207c26$var$initialized = new WeakSet();
var $34a400a481207c26$var$currentOpenWrap = null;
var $34a400a481207c26$var$listeningDocuments = new WeakSet();
function $34a400a481207c26$var$listenOnDocument(doc) {
    if ($34a400a481207c26$var$listeningDocuments.has(doc)) return;
    $34a400a481207c26$var$listeningDocuments.add(doc);
    doc.addEventListener('keydown', function(e) {
        if (!$34a400a481207c26$var$currentOpenWrap || e.key !== 'Escape') return;
        var trigger = $34a400a481207c26$var$currentOpenWrap.querySelector('.custom-select__trigger');
        $34a400a481207c26$var$currentOpenWrap.classList.remove('is-open');
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
        }
        $34a400a481207c26$var$currentOpenWrap = null;
    });
    doc.addEventListener('click', function(e) {
        if ($34a400a481207c26$var$currentOpenWrap && !$34a400a481207c26$var$currentOpenWrap.contains(e.target)) {
            var trigger = $34a400a481207c26$var$currentOpenWrap.querySelector('.custom-select__trigger');
            $34a400a481207c26$var$currentOpenWrap.classList.remove('is-open');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            $34a400a481207c26$var$currentOpenWrap = null;
        }
    });
}
function $34a400a481207c26$var$buildCustomSelect(select) {
    if ($34a400a481207c26$var$initialized.has(select)) return;
    var doc = select.ownerDocument;
    var view = doc.defaultView;
    $34a400a481207c26$var$listenOnDocument(doc);
    var wrap = doc.createElement('div');
    wrap.className = 'custom-select';
    var trigger = doc.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    var prefix = select.dataset.prefix;
    if (prefix) {
        var prefixEl = doc.createElement('span');
        prefixEl.className = 'custom-select__prefix';
        prefixEl.textContent = prefix;
        trigger.appendChild(prefixEl);
    }
    var labelEl = doc.createElement('span');
    labelEl.className = 'custom-select__label';
    var iconEl = doc.createElement('span');
    iconEl.className = 'custom-select__icon';
    iconEl.setAttribute('aria-hidden', 'true');
    trigger.append(labelEl, iconEl);
    var list = doc.createElement('ul');
    list.className = 'custom-select__options';
    list.setAttribute('role', 'listbox');
    Array.from(select.options).forEach(function(opt) {
        var li = doc.createElement('li');
        li.className = 'custom-select__option';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(opt.selected));
        li.dataset.value = opt.value;
        li.textContent = opt.text;
        list.appendChild(li);
    });
    select.insertAdjacentElement('beforebegin', wrap);
    wrap.appendChild(select);
    wrap.appendChild(trigger);
    wrap.appendChild(list);
    var optionEls = Array.from(list.querySelectorAll('.custom-select__option'));
    function syncDisplay() {
        var sel = select.options[select.selectedIndex];
        labelEl.textContent = sel ? sel.text : '';
        wrap.classList.toggle('is-placeholder', !select.value);
        optionEls.forEach(function(li) {
            li.setAttribute('aria-selected', String(li.dataset.value === select.value));
        });
    }
    syncDisplay();
    function close() {
        wrap.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if ($34a400a481207c26$var$currentOpenWrap === wrap) $34a400a481207c26$var$currentOpenWrap = null;
    }
    function open() {
        if ($34a400a481207c26$var$currentOpenWrap && $34a400a481207c26$var$currentOpenWrap !== wrap) {
            $34a400a481207c26$var$currentOpenWrap.classList.remove('is-open');
            var otherTrigger = $34a400a481207c26$var$currentOpenWrap.querySelector('.custom-select__trigger');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        $34a400a481207c26$var$currentOpenWrap = wrap;
    }
    function pick(value) {
        select.value = value;
        select.dispatchEvent(new view.Event('change', {
            bubbles: true
        }));
        syncDisplay();
        close();
        trigger.focus();
    }
    trigger.addEventListener('click', function() {
        wrap.classList.contains('is-open') ? close() : open();
    });
    list.addEventListener('click', function(e) {
        var li = e.target.closest('.custom-select__option');
        if (li) pick(li.dataset.value);
    });
    // Forward CF7 validation class to wrapper
    new view.MutationObserver(function() {
        wrap.classList.toggle('custom-select--invalid', select.classList.contains('wpcf7-not-valid'));
    }).observe(select, {
        attributes: true,
        attributeFilter: [
            'class'
        ]
    });
    // Re-sync on native change
    select.addEventListener('change', syncDisplay);
    if (select.form) select.form.addEventListener('reset', function() {
        setTimeout(syncDisplay, 0);
    });
    $34a400a481207c26$var$initialized.add(select);
}
function $34a400a481207c26$export$2e2bcd8739ae039() {
    var root = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    root.querySelectorAll('.wpcf7 select, .js-custom-select').forEach($34a400a481207c26$var$buildCustomSelect);
}
if (!(0, $1MMdM.isBlockEditor)()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
        return $34a400a481207c26$export$2e2bcd8739ae039();
    });
    else $34a400a481207c26$export$2e2bcd8739ae039();
}

});
parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "findBlocks", function () { return $14cfaddf7b657fa6$export$ee06a5357e65c7df; });
$parcel$export(module.exports, "isBlockEditor", function () { return $14cfaddf7b657fa6$export$22780c2770c6471f; });
$parcel$export(module.exports, "bootBlock", function () { return $14cfaddf7b657fa6$export$3ba659c19d85cb2f; });

var $2Xzd1 = parcelRequire("2Xzd1");
function $14cfaddf7b657fa6$var$findAll(root, selector) {
    var found = Array.from(root.querySelectorAll(selector));
    return root.matches && root.matches(selector) ? [
        root
    ].concat((0, $2Xzd1._)(found)) : found;
}
function $14cfaddf7b657fa6$export$ee06a5357e65c7df(root, selector) {
    return $14cfaddf7b657fa6$var$findAll(root, selector);
}
function $14cfaddf7b657fa6$export$22780c2770c6471f() {
    return Boolean(window.acf) && document.body.classList.contains('block-editor-page');
}
function $14cfaddf7b657fa6$export$3ba659c19d85cb2f(slug, init) {
    if ($14cfaddf7b657fa6$export$22780c2770c6471f()) {
        window.acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            init($block.get(0), {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});





parcelRequire("4wcHu");
})();
//# sourceMappingURL=custom-select.js.map
